import styled from 'styled-components'
import { P as PKS, Div as DivKonsys } from 'konsys-ui'

export const Div = styled.div`
  position: absolute;
  top: -9px;
`

export const a = styled.div`
`

export const P = styled(PKS)`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`

export const CardStyled = styled(DivKonsys)`
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-sizing: border-box;
  box-shadow: 0px 5px 20px 5px rgba(185, 185, 185, 0.15);
  border-radius: 10px;
`
